"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _BulkSaveTagRequest = require("./BulkSaveTagRequest");
Object.keys(_BulkSaveTagRequest).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _BulkSaveTagRequest[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _BulkSaveTagRequest[key];
    }
  });
});
var _BulkSaveTagResponse = require("./BulkSaveTagResponse");
Object.keys(_BulkSaveTagResponse).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _BulkSaveTagResponse[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _BulkSaveTagResponse[key];
    }
  });
});
var _SaveTagRequest = require("./SaveTagRequest");
Object.keys(_SaveTagRequest).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SaveTagRequest[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SaveTagRequest[key];
    }
  });
});
var _SaveTagResponse = require("./SaveTagResponse");
Object.keys(_SaveTagResponse).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SaveTagResponse[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SaveTagResponse[key];
    }
  });
});